import {GTM_ACCOUNT_ID} from '../config.js';

export default class GTMHelper {

	GTM = (e,t,n,r,i) => {
		e[r]=e[r]||[];
		e[r].push({"gtm.start":(new Date).getTime(),event:"gtm.js"});
		var s=t.getElementsByTagName(n)[0],
			o=t.createElement(n),
			u=r!="dataLayer"?"&l="+r:"";
		o.async=true;
		o.src="//www.googletagmanager.com/gtm.js?id="+i+u;
		s.parentNode.insertBefore(o,s)
	}
	
	GTMCall = () => {
		this.GTM(window,document,"script","dataLayer",GTM_ACCOUNT_ID);
	}
}


// WEBPACK FOOTER //
// ../q-cars/src/utils/GTMHelper.js